<div class="select-wrapper">
  <div class="select">
    <div #select class="select-top">
      <p *ngIf="showName" class="selected-item align-text-vertically" (click)="onOpen()">
        {{ selectedValue?.name }}
      </p>

      <button mat-icon-button (click)="onOpen()">
        <mat-icon *ngIf="!isOpened" class="chevron-icon">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="isOpened" class="chevron-icon">keyboard_arrow_up</mat-icon>
      </button>
    </div>

    <div class="select-list" #selectList [hidden]="!isOpened">
      <div *ngFor="let option of options" class="select-list-item" (click)="onChange(option)">
        <span class="select-list-item-text align-text-vertically">{{ option.name }}</span>

        <img *ngIf="selectedValue?.value === option.value" class="selected-item-icon"
          src="./assets/images/check-mark.svg">
      </div>
    </div>
  </div>
</div>
